module.exports = __webpack_public_path__ + "img/app-header-mypage.8cb4bb18.svg";